import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'g-drag-canvas',
  setup(__props) {

const width = ref(0)
const height = ref(0)

onMounted(() => {
  document.addEventListener('resize', getSize)
  getSize()
})

onUnmounted(() => {
  document.removeEventListener('resize', getSize)
})

/** 获取可视宽高 */
function getSize() {
  width.value =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth
  height.value =
    window.innerHeight ||
    document.documentElement.clientHeight ||
    document.body.clientHeight
}

return { __sfc: true,width, height, getSize }
}

})